export const keying_py_comercial = (razon_social, documento) => {
  return [
    {
      request: {
        session: {
          quoteback: "",
          customerId: "",
          profileId: "dfkl_py_profile_commercial_docregdatename_exactlyfuzzy_1",
          entityType: "COMMERCIAL",
        },
        entity: {
          consumer:null,
          commercial: {
            names: [
              {
                data: {
                  NAME_PREFIX: "",
                  NAME_LAST_NAME: "",
                  NAME_BUSINESS_NAME: razon_social,
                  NAME_MIDDLE_NAME: "",
                  NAME_FIRST_NAME: "",
                  NAME_LEGAL_BUSINESS_NAME: "",
                  NAME_SUFFIX: "",
                },
              },
            ],
            identifiers: {
              IDENTIFIER_BUSINESS_ID: documento,
              IDENTIFIER_ORIGIN_COUNTRY_NUMERIC_CODE: "600",
              IDENTIFIER_ORIGIN_COUNTRY_NAME: "PARAGUAY",
              IDENTIFIER_BUSINESS_COUNTRY: "PY",
              IDENTIFIER_SSN: "",
              IDENTIFIER_ORIGIN_COUNTRY_CODE: "PY",
              IDENTIFIER_STATEDL: "",
              IDENTIFIER_BUSINESS_ID_TYPE: "3",
              IDENTIFIER_BUSINESS_REGISTRATION_DATE: "1996-09-10 00:00:00.000",
            },
            website: {},
            discoveryData: {},
            lineageKey: "",
            legacyIds: {},
            phones: {},
            emails: {},
            owners: {},
            addresses: [],
          },
          
        },
      },
      response: null,
    },
  ];
};
